import { Component } from '@inter-ikea-core/core';
import { LabelPosition } from '../..';

/**
 * Holds information about the helplines outer measurement line positions to be
 * used by HelpLinesOuterMeasurementsWidget and HelpLinesOuterMeasurementSystem to place
 * the labels correctly
 */
export default class HelpLinesOuterMeasurementsLineCenterComponent implements Component {
  static id = 2057;
  measurements: LabelPosition[];
  typeId = HelpLinesOuterMeasurementsLineCenterComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  constructor(measurements: LabelPosition[]) {
    this.measurements = measurements;
  }

  eq() {
    return false;
  }
}
